import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled from 'styled-components';

const ContainerWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
  }
`;

const ContentWrapper = styled.aside``;

const MenuWrapper = styled.nav`
  border-bottom: 1px solid ${color.gainsboro};
  width: 100%;
  padding: 10px 20px;
  background-color: ${color.light};

  @media ${device.tablet} {
    border: 1px solid ${color.gainsboro};
    border-radius: 3px;
    margin-bottom: 20px;
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: unset;
  }
`;

export { ContainerWrapper, ContentWrapper, MenuWrapper };
